import { render, staticRenderFns } from "./OhsSectionEditor.vue?vue&type=template&id=65321d14"
import script from "./OhsSectionEditor.vue?vue&type=script&lang=ts"
export * from "./OhsSectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./OhsSectionEditor.vue?vue&type=style&index=0&id=65321d14&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports